/**
 * Handle ajax navigation behavior
 */

window.app = window.app || {};

(function (navigationManager, $) {

    /**
     * Mobile menu selector
     * @type {string}
     */
    var percent = 0;
    var chrono;
    var xhrCallback;
    /**
     * Initializes the behavior.
     */
    navigationManager.init = function (callback) {
        if ( ! $('html').hasClass('xhr-loaded')) {
            _handleEvents();

            $('html').addClass('xhr-loaded');
        }

        xhrCallback = callback;
    };

    /**
     * Handle events
     */
    var _handleEvents = function () {
        $(document).on('click', '.ab-item', function(e){
           e.preventDefault();
        });

        $( document ).on( 'click', 'a[href*="//' + _getBaseUrl() + '"]:not(.ab-item)', function(e) {
            e.preventDefault();
            var _url = $(this).attr('href');

            if (_url.substr(0, 1) !== "#") {
                history.pushState(_url, null, _url);
                _do_ajax_request(_url);
            }

            return false;
        });

        window.addEventListener('popstate', function(e){
            if (e.state !== null) {
                var character = e.state;
                _do_ajax_request(character);
            } else {
                _do_ajax_request(document.location.host + '/#');
            }
        });

        $(window).on('load', function() {
            _afterTransition();
        });
    };

    /**
     * Get current URI
     */
    var _getBaseUrl = function() {
        var l = document.createElement("a");
        l.href = window.location.href;
        return l.hostname;
    };

    /**
     * Handle AJAX Query
     */

    var _do_ajax_request = function( slug ) {

        __beforeTransition();

        _perform_ajax_request( slug );
    };

    /**
     * Perform AJAX Query
     */
    var _perform_ajax_request = function( url ) {
        $.ajax({
            url    : url,
            type   : 'POST',
            dataType: "html",
            headers: {
                'X-Requested-With':'BAWXMLHttpRequest'
            }
        }).done( function( data ) {
            _parseXhrResponse(data);
            xhrCallback();
        }).error( function() {
            console.log('xhr error');
        });
    };

    /**
     * Parse Ajax query response
     */

    var _parseXhrResponse = function(data) {

        var $dom = $(document.createElement("html"));
        $dom[0].innerHTML = data; // Here's where the "magic" happens
        var _bodyClass = $($dom).find("body").attr('class');
        var _title = $(data).filter('title');
        document.title = _title.html();

        var _content = $(data).find('#content');
        var _headerNav = $(data).find('header');

        $('header').removeClass('show-menu').html($(_headerNav).html());
        $('#content').html(_content.html());
        $('body').attr('class', _bodyClass);

        _afterTransition();
    };

    var __beforeTransition = function() {

        $('header').animate({'opacity': 0}, 'easeOutQuad');
        $('footer').animate({'opacity': 0}, 'easeOutQuad');
        $('#content').animate({'opacity': 0}, function() {
            $('body, html').scrollTop(0);
        });
    };

    var _afterTransition = function() {
        $('header').animate({opacity: '1'}, 'easeOutQuad');
        $('#content').animate({opacity: '1'}, 'easeOutQuad');
        $('footer').animate({'opacity': 1}, 'easeOutQuad');
    };
})(
    window.app.navigationManager = window.app.navigationManager || {},
    jQuery
);
